import { render, staticRenderFns } from "./RsaAdiProtocolliListComponent.vue?vue&type=template&id=13367886"
import script from "./RsaAdiProtocolliListComponent.vue?vue&type=script&lang=js"
export * from "./RsaAdiProtocolliListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports